<template>
    <div>
       <div class="container-collab d-flex w-full h-full">
         <div class="col-md-3  w-full h-full">
           <filterdetailsmiscellaneous  @search="search"></filterdetailsmiscellaneous>
         </div>
         <div class="col-md-9">
             <div class="table-detalhes">
             <Tables ref="tableGridLotePagoDetalhesDiversos"
                   :columns="['Lote','Pedido','Funcionários','Função','Obra','Data Aprovação Coordenador','Data Aprovação Tranpostes','Data Aprovação Diretoria','Início viagem','Fim viagem','Qtd. Despesas','Total Gastos','']"
                   :showReload="false"
                   v-on:Load="onLoad"
                   :showButtonNew="true"
                   :newHeaderStatus="true"
                   :showHeader="true"
                   >
                   <tr v-for="data in ArrayLotePagosDetalhes" :key="data.funcionarioId">
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="data.lote == null ? 'N/D': data.lote" />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="data.pedido == null ? 'N/D' : data.pedido " />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="data.funcionario == null ? 'N/D' : data.funcionario " />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="data.cargo == null ? 'N/D' : data.cargo" />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="data.obra == null ? 'N/D' : data.obra" />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="formataData(data.dataCoordenador == null ? 'N/D' : data.dataCoordenador)" />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="formataData(data.dataControladoria == null ? 'N/D' : data.dataControladoria)" />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="formataData(data.dataDiretoria == null ? 'N/D' : data.dataDiretoria)" />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="formataData(data.dataInicial == null ? 'N/D' : data.dataInicial)" />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="formataData(data.dataFinal == null ? 'N/D' : data.dataFinal)" />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="data.quantidadeDespesa == null ? 'N/D' : data.quantidadeDespesa" />
                       <TableColumn :IsText="true"   v-on:Edit="ModalPopup(data)" :status="data.demissaoData != null ? 0 : 1" :value="formatMoney(data.totalGasto == null ? 'N/D' : data.totalGasto)" />
                       <!-- <TableColumn :IsOnlyPedido="data.codigoEmpresa === 8 ? true : false" :disabled="data.pedido == null" v-on:Pedido="showModalPedido(data)" /> -->
                       <TableColumn :IsOnlyPedido="!isConsulta && data.codigoEmpresa === 8 && data.pedido === null" disabled v-on:Pedido="showModalPedido(data)"/>
                   </tr>
                     <template #ButtonsAprova>
                         <div class="button-container">
                           <button type="button" v-on:click="$router.back()" class="btn btn-third btn-sm ml-3" ><i style="font-size:16px;padding-top:2px" class="fas fa-arrow-circle-left "></i></button>
                         </div>
                     </template>
               </Tables>
             </div>
         </div>
       </div>
         <b-modal
           centered hide-footer
           ref="popupExpense"
           :no-close-on-backdrop="true"
           size="xl"
           title="Despesas por Funcionário"
           >
           <h4 class="label mb-2"><strong>Lote: {{modalDetalhes.lote}}</strong></h4>
       <div class="date">
                     <div class="date-container">
                       <div class="date-content" style="width:25%">
                         <h5>Data Início:</h5>
                         <h6>{{modalDetalhes.dataInicialFormatado == null ? 'N/D' : modalDetalhes.dataInicialFormatado }}</h6>
                       </div>
                       <div class="date-content" style="width:75%">
                         <h5>Data Encerramento:</h5>
                         <h6>{{modalDetalhes.dataFinalFormatado == null ? 'N/D' : modalDetalhes.dataFinalFormatado}}</h6>
                       </div>
                     </div>
                     <div>
                        <i style="font-size:20px; cursor:pointer;" class="fa fa-download" @click="onExportAllImages()"></i>
                     </div>
                 </div>
                 <Tables ref="tableGridLotePagoDetalhesModalDiversos"
                   :columns="['Categoria', 'Quantidade', 'Data Despesa', 'Total Gasto','']"
                   :showReload="false"
                    v-on:Load="modalInfo()"
                   :showButtonNew="true"
                   :newHeaderStatus="true"
                   :showHeader="true"
                   >
                   <tr v-for="(data, index) in LotesEmployee" :key="index">
                       <TableColumn
                         :IsText="true"
                         :status="1"
                         :value="data.subCategoria ? data.subCategoria : 'N/D'"
                       />
                       <TableColumn
                         :IsText="true"
                         :status="1"
                         :value="data.quantidade == null ? 'N/D' : data.quantidade"
                       />
                       <TableColumn
                         :IsText="true"
                         :status="1"
                         :value="data.dataRegistroDespesa == null ? 'N/D' : data.dataRegistroDespesa"
                       />
                       <TableColumn
                         :IsText="true"
                         :status="1"
                         :value="formatMoney(data.total)"
                         />
                       <TableColumn
                         :IsDocumentActions="true"
                         :HasDownload="false"
                         :HasDocumentDelete="false"
                         :status="1"
                       />
                     </tr>
               </Tables>
            <div class="total-container">
               <h4 class="label-total mb-2"><strong>Total: {{ formatMoney( modalDetalhes.total) }} </strong></h4>
            </div>
       </b-modal>
       <b-modal
        centered hide-footer
        title="PEDIDO"
        ref="ModalGerarPedido"
        :no-close-on-backdrop="true"
        size="md"
      >
      <div v-if="PedidoGerado === false">
        <div class="flex">
          <i class="fas fa-file-invoice-dollar icon-pedido">
        </i></div>
        <div class="flex font-label">
          Deseja gerar o pedido ?
        </div>

        <div class="container-buttons-form pt-3">
            <button @click="cancelPedido" class="button-cancel">Cancelar</button>
            <button @click="showModalPedidoGerado" class="button-save">GERAR</button>
        </div>
      </div>
      <div v-if="PedidoGerado === true">
        <div class="flex">
         <i class="fas fa-check-circle icon-pedido iconeSucesso"></i>
        </div>
        <div class="flex font-label">
        Gerado com Sucesso
        </div>

        <div class="flex font-label-menor">
         ORDEM DO PEDIDO
        </div>
        <div class="flex-pedido ">
          <div class="font-label divPedido" v-for="obj in pedido.data.itens" v-bind:key="obj.funcionarioid">
             {{obj.numPedidoGerado}}
          </div>
        </div>

        <div class="container-buttons-form pt-3">
            <button @click="cancelPedido" class="button-cancel">FECHAR</button>
        </div>
      </div>
    </b-modal>
    </div>
   </template>

<script>
import detailsmiscellaneouspaidlots from './detailsmiscellaneouspaidlots'
export default detailsmiscellaneouspaidlots
</script>

<style scoped>
   .container-collab{
     justify-content: space-between;
   }
   .head{
     margin-bottom: 1rem;
   }
   .details-body{
       height: 70vh;
       overflow: auto;
       background: white;
       border: 1px solid rgb(145, 145, 145) ;
   }
   .button-container{
     display: flex;
     align-items: center;
     justify-content: center;
     width:100%;
     height: 45px;
   }

   .date{
     display: flex;
     width: 100%;
     height: 100%;
     align-items: center;
     justify-content: flex-start;
   }
   .date-container{
     width: 100%;
     height: 100%;
     display: flex;
     align-items: center;
     justify-content: space-between;
   }
   .details-modal{
     padding:1.2rem;
   }
   .label-total{
     padding: 0 1.2rem 0 1.2rem;
   }
   .total-container{
     display: flex;
     width: 100%;
     height: 100%;
     align-content: center;
     justify-content: flex-end;
   }
   .divPedido {
  margin: 5px;
  padding: 10px;
  border-radius: 10px;
  background-color: rgb(243, 243, 243);
  height: fit-content;
  width: 7rem;
  }
  .button-cancel,
  .button-save{
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
  }
  .button-cancel{
    background-color: #c40000;
    color: white;
  }
  .button-save{
    background-color: #008148;
    color: white;
  }
  .container-buttons-form{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
  }
  .container-collab{
    justify-content: space-between;
  }
  .iconeSucesso {
    color: #008148;
  }
  .flex {
  display: flex;
  justify-content: center;
  }
  .flex-pedido {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .icon-pedido{
    font-size: 60px;
    padding: 1rem
  }
  .font-label-menor{
    padding-top: 1rem;
  font-size: 13px;
  }
  .font-label{
  font-size: 16px;
  font-weight: bold;
  }
   </style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/tablelotspaid/components/detailsmiscellaneouspaidlots.vue